import React, { memo } from 'react'
import { FormControl, InputAdornment } from '@mui/material'

import CustomTextField from './CustomTextField'
import CustomFormLabel from './CustomFormLabel'
import { buildCustomHelperTextStyles } from '../../../util/style.helpers'
import { checkRulesAgainstValue } from '../../../util/validation.helpers'

const Input = ({
  label,
  id,
  type,
  bottomLabel,
  errorMessage,
  successMsg,
  onChange,
  inputProps,
  validate,
  startIcon,
  fullWidth = true,
  autoComplete = 'off',
  required = true,
  size = '',
  variant = 'outlined',
  ...restProps
}) => {
  const handleOnChangeInput = ({ target }) => {
    const value = target.value
    if (onChange) {
      if (validate && validate.length > 0) {
        if (value) {
          const isValid = checkRulesAgainstValue(validate, value).length === 0
          isValid && onChange(value)
        } else {
          onChange('')
        }
      } else {
        onChange(value)
      }
    }
  }

  const getCorrectType = () => {
    return type || 'text'
  }
  const error = Boolean(errorMessage)
  return (
    <FormControl fullWidth={fullWidth} error={error}>
      {label && <CustomFormLabel htmlFor={id}>{label}</CustomFormLabel>}
      <CustomTextField
        id={id}
        type={getCorrectType()}
        fullWidth={fullWidth}
        required={required}
        error={error}
        helperText={errorMessage || successMsg || bottomLabel}
        FormHelperTextProps={buildCustomHelperTextStyles(successMsg)}
        inputProps={inputProps}
        InputProps={{
          startAdornment: startIcon && (
            <InputAdornment position='start'>{startIcon}</InputAdornment>
          )
        }}
        onChange={handleOnChangeInput}
        size={size}
        variant={variant}
        autoComplete={autoComplete}
        {...restProps}
      />
    </FormControl>
  )
}

export default memo(Input)
